export default __webpack_public_path__ + "static/media/group5.c1f5c736.png";